module.exports = __webpack_public_path__ + "assets/img/若比邻超市.e8237bdc.png";